import React from "react";
import "./Styles/header.css"

export default function Header(){
    return(
        <section class="info">
            <h1 id = "title">Drake M</h1>
            <p id ="subtitle">Game Developer & Software Engineer</p>
        </section>
    )
}